import { MapPin } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { CONTACT } from "../../content/site";
import { SectionHead } from "./SectionHead";
import { Reveal } from "./motion";

const Rings = () => {
  const reduce = useReducedMotion();
  return (
    <div className="relative mx-auto grid aspect-square w-full max-w-[420px] place-items-center">
      {[1, 0.74, 0.48].map((s, i) => (
        <motion.span
          key={s}
          className="absolute rounded-full border border-[#1E5631]/25"
          style={{ width: `${s * 100}%`, height: `${s * 100}%` }}
          animate={reduce ? {} : { scale: [1, 1.04, 1] }}
          transition={{ duration: 6, repeat: Infinity, delay: i * 0.8, ease: "easeInOut" }}
        />
      ))}
      <span className="absolute h-[22%] w-[22%] rounded-full bg-[#DCEFBE]" />
      <span className="relative grid h-14 w-14 place-items-center rounded-full bg-[#1E5631] text-[#FBF9F4] shadow-lg">
        <MapPin className="h-6 w-6" />
      </span>
    </div>
  );
};

export const Area = () => (
  <section id="einzugsgebiet" data-testid="area-section" className="bg-[#F3EFE6] py-24 md:py-36">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-2">
      <div>
        <SectionHead eyebrow="Einzugsgebiet" lines={["Hier sind wir", "für Sie unterwegs."]} />
        <Reveal delay={0.15}>
          <p data-testid="area-placeholder" className="mt-8 inline-flex items-center gap-3 rounded-full border border-[#C5BC9F] bg-[#FBF9F4] px-6 py-3 font-display text-xl text-[#1B281E]">
            <MapPin className="h-5 w-5 text-[#C86D51]" /> {CONTACT.area}
          </p>
          <p className="mt-6 max-w-md text-[#4B5B4E]">Sie sind sich nicht sicher, ob Ihr Garten im Einzugsgebiet liegt? Fragen Sie einfach kurz nach.</p>
        </Reveal>
      </div>
      <Reveal delay={0.1}><Rings /></Reveal>
    </div>
  </section>
);
